import React from 'react';
import i18n from '../../../i18n';
import { Counter } from '@homeexchange/design';
var CounterGuestNb = function (_a) {
    var _b;
    var guestsData = _a.guestsData, onNbGuestChange = _a.onNbGuestChange;
    var _c = ((_b = guestsData === null || guestsData === void 0 ? void 0 : guestsData.size) === null || _b === void 0 ? void 0 : _b.beds) || {}, adults = _c.adults, children = _c.children, babies = _c.babies;
    var changeValue = function (label, value) {
        var _a;
        var _b = ((_a = guestsData === null || guestsData === void 0 ? void 0 : guestsData.size) === null || _a === void 0 ? void 0 : _a.beds) || {}, adults = _b.adults, children = _b.children, babies = _b.babies;
        if (label === 'adults') {
            return onNbGuestChange(value, children, babies);
        }
        else if (label === 'children') {
            return onNbGuestChange(adults, value, babies);
        }
        return onNbGuestChange(adults, children, value);
    };
    return (React.createElement("div", { className: "container-counter-guests" },
        React.createElement("div", null,
            React.createElement(Counter, { inputInitialValue: adults || 1, label: i18n.t('user:traveler.type_adult_plural'), onChange: function (value) { return changeValue('adults', value); }, maxValue: 19, minValue: 1 })),
        React.createElement("div", null,
            React.createElement(Counter, { inputInitialValue: children || 0, label: i18n.t('user:traveler.type_child_plural'), onChange: function (value) { return changeValue('children', value); }, maxValue: 19 })),
        React.createElement("div", null,
            React.createElement(Counter, { inputInitialValue: babies || 0, label: i18n.t('user:traveler.type_baby_plural'), onChange: function (value) { return changeValue('babies', value); }, maxValue: 19 }))));
};
export default CounterGuestNb;
